import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { CalibrationBalanceFilter } from '../../../../model/calibrationBalance';
import { GenericClass } from '../../../../model/genericClass';
import { MyErrorStateMatcher } from '../../../../utils/errorStateMatcher';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { CustomDatepickerHeaderComponent } from '../../../shared/datepicker-custom-header/datepicker-custom-header.component';
import { Subject, takeUntil } from 'rxjs';
import { AppTypeService } from '../../../../services/appType.service';
import { ClientService } from '../../../../services/client.service';
import { UsersService } from '../../../../services/users.service';
import { Client } from '../../../../model/client';
import { User } from '../../../../model/user';
import { AppTypeEnum } from 'src/app/model/appType';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-calibration-balance-list-filter',
  templateUrl: './calibration-balance-list-filter.component.html',
  styleUrl: './calibration-balance-list-filter.component.scss',
  standalone: false
})
export class CalibrationBalanceListFilterComponent implements OnInit, OnDestroy {

  @Output() filterEmitter = new EventEmitter<CalibrationBalanceFilter>();

  filter: CalibrationBalanceFilter;

  statuses: GenericClass[];

  clients: Client[];
  clientsFiltered: Client[];

  users: User[];
  usersFiltered: User[];

  expandedFilter = true;

  matcher = new MyErrorStateMatcher();
  form: UntypedFormGroup;

  customDatepickerHeader = CustomDatepickerHeaderComponent;

  private destroy$ = new Subject<void>();

  constructor(
    fb: UntypedFormBuilder,
    private appTypeService: AppTypeService,
    private clientService: ClientService,
    private userService: UsersService) {
    this.cleanFilter();

    this.form = fb.group({
      idStatus: [this.filter.idStatus],
      idClient: [this.filter.idClient],
      regUser: [this.filter.regUser],

      name: [this.filter.name],
      type: [this.filter.type],

      maker: [this.filter.maker],
      model: [this.filter.model],

      serialNum: [this.filter.serialNum],
      certificateNum: [this.filter.certificateNum],

      projectNo: [this.filter.projectNo],

      calibrateDateStart: [this.filter.calibrateDateStart],
      calibrateDateEnd: [this.filter.calibrateDateEnd],
      expirationDateStart: [this.filter.expirationDateStart],
      expirationDateEnd: [this.filter.expirationDateEnd],

      realizationFcStart: [this.filter.realizationFcStart],
      realizationFcEnd: [this.filter.realizationFcEnd],
      idPlace: [this.filter.idPlace]
    });
  }

  ngOnInit(): void {
    this.statuses = [];
    this.clients = [];
    this.clientService.findAll().pipe(takeUntil(this.destroy$)).subscribe((data: Client[]) => this.clients = data);

    this.users = [];
    this.userService.findAllFromGroupAppType(AppTypeEnum.CALIBRATES).pipe(takeUntil(this.destroy$))
      .subscribe((data: User[]) => this.users = data);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  doFilter(): void {
    this.expandedFilter = false;

    this.filterEmitter.emit(this.filter);
  }

  cleanFilter(): void {
    this.filter = new CalibrationBalanceFilter();
  }

  saveDate(field: string, event: any): void {

    let value: Date | string = event.target.value;
    if (value != null) {

    if (value instanceof Date) {
      value = DateTime.fromJSDate(value).toFormat('dd/MM/yyyy');
    }

    const date = DateTime.fromFormat(value + ' 12:00:00 +00:00', 'dd/MM/yyyy HH:mm:ss ZZZ').toJSDate();
    while (date.getFullYear() < 1970) {
      date.setFullYear(date.getFullYear() + 100);
    }

      this.filter[field] = date;
    } else {
      this.filter[field] = null;
    }

  }

}
